/*--------------------------------------
 ANIMATIONS
 --------------------------------------*/
Animations = {
    init: function () {
        var controller = new ScrollMagic.Controller();
        //FADEINUP
        $('[data-fadeinup]').each(function () {
            var tw = new gsap.timeline();
            tw.from(this, 1.8, { ease: Expo.easeOut, y: 25 })
                .to(this, 1.5, { opacity: 1 }, 0);

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: .92,
                reverse: true
            })
                .setTween(tw)
                //.addIndicators()
                .addTo(controller);
        });

        //FADEIN
        $('[data-fadein]').each(function () {
            var tw = new gsap.timeline();
            tw.to(this, 1.5, { opacity: 1 });

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                reverse: true
            })
                .setTween(tw)
                //.addIndicators()
                .addTo(controller);
        });


        $('[data-fadeinfast]').each(function () {
            var tw = new gsap.timeline();
            tw.to(this, 1, { opacity: 1 });

            var scene = new ScrollMagic.Scene({
                triggerElement: this,
                triggerHook: 1,
                reverse: true
            })
                .setTween(tw)
                //.addIndicators()
                .addTo(controller);
        });


    }
};

/*--------------------------------------
                 OTHERS 
 --------------------------------------*/
dynamicViewHeight = {
    init: function () {
        updateViewHeight();

        //window.addEventListener("resize", updateViewHeight);
        window.addEventListener("orientationchange", updateViewHeight);

        function updateViewHeight() {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
    }
};

/*----------------------
       MENU
---------------------- */
Menu = {
    init: function () {
        $(".section-header .btn-submenu").on("click", function (e) {
            e.preventDefault();
            var parent_this = $(this).closest(".header-menu__nav--lists");
            $('.header-menu__nav--lists').not(parent_this).removeClass('open');
            parent_this.toggleClass("open");
            $("body").removeClass("open-submenu-home");
            $("body").toggleClass("open-submenu");

        });

        $(".section-header-home .btn-submenu").on("click", function (e) {
            e.preventDefault();
            var parent_this = $(this).closest(".header-menu__nav--lists");
            $('.header-menu__nav--lists').not(parent_this).removeClass('open');
            parent_this.toggleClass("open");
            $("body").removeClass("open-submenu");
            $("body").toggleClass("open-submenu-home");
        });



        $("body").on("click", function (e) {
            if (!$(e.target).closest('.btn-submenu, .submenu').length) {
                $('.header-menu__nav--lists').removeClass('open');
                $("body").removeClass("open-submenu");
            }
        });
    }
};

/*----------------------
       MENU MOBILE
---------------------- */
MenuMobile = {
    init: function () {
        $(".btn-submenu-mobile").on("click", function (e) {
            e.preventDefault();
            $(this).closest(".header-mobile__nav--lists").toggleClass("open");
        });

        $(".btn-menu-mobile").on("click", function (e) {
            e.preventDefault();
            $("body").toggleClass("open-menu-mobile");
            $("body").toggleClass('no-scroll');
            $("body").removeClass('cart-notification-open');
            $(".cart-notification").removeClass('cart-notification-active');
        });

    }
};

/*----------------------
SEARCH
----------------------*/
Search = {
    init: function () {

        //OPEN IN MENU
        $(".section-header .btn-search").on("click", function (e) {
            e.preventDefault();
            $(".section-header .search-input").addClass("open");
            $("body").removeClass("open-search-home");
            $("body").addClass("open-search");
            $(".section-header .search-input input.input-search").val("");
            setTimeout(function () {
                $(".section-header .search-input input.input-search").focus();
            }, 300);
        });

        $(".section-header .search-input input.input-search").on("input", function () {
            $(".section-header .search-input__content").addClass("start");
        });

        //OPEN IN MENU HOME
        $(".section-header-home .btn-search").on("click", function (e) {
            e.preventDefault();
            $(".section-header-home .search-input").addClass("open");
            $("body").removeClass("open-search");
            $("body").addClass("open-search-home");
            $(".section-header-home .search-input input.input-search").val("");
            setTimeout(function () {
                $(".section-header-home .search-input input.input-search").focus();
            }, 300);
        });

        $(".section-header-home .search-input input.input-search").on("input", function () {
            $(".section-header-home .search-input__content").addClass("start");
        });


        //CLOSE
        $(".btn-close-search").on("click", function () {
            $(".search-input").removeClass("open");
            $(".search-input input.input-search").val("");
            $(".search-input__content").removeClass("start");
            $("body").removeClass("open-search");
            $("body").removeClass("open-search-home");
        });

        $("body").on("click", function (e) {
            if (!$(e.target).closest('.btn-search, .search-input').length) {
                $(".search-input").removeClass("open");
                $(".search-input input.input-search").val("");
                $(".search-input__content").removeClass("start");
                $("body").removeClass("open-search");
                $("body").removeClass("open-search-home");
            }
        })
    }
};


/*----------------------
MUSIC
----------------------*/
Music = {
    init: function () {
        const audioPlayer = $('#audio-player')[0];
        const playlistData = $('.music-player').data('playlist');

        let playlist = playlistData || [];
        let currentTrackIndex = 0;

        // Carrega la primera pista si la llista de reproducció no està buida
        if (playlist.length > 0) {
            loadTrack(currentTrackIndex);
        } else {
            $('#track-name').text("NO HAY MÚSICA DISPONIBLE");
        }

        // Carrega la pista actual
        function loadTrack(index) {
            const track = playlist[index];

            if (typeof track === "string" && track.trim() !== "" || typeof track === "object" && track !== null) {
                audioPlayer.src = track.url;
                $('#track-name .label').show();
                $('#track-name .error').hide();
                $('#track-name .name').text(track.name);

            } else {
                $('#track-name .label').hide();
                $('#track-name .error').show();
            }
        }

        // Funció per reproduir o pausar
        function togglePlayPause() {
            if (checkMusic(audioPlayer.src)) {
                if (audioPlayer.paused) {
                    audioPlayer.play();
                    $('#play-icon').hide();
                    $('#pause-icon').show();
                } else {
                    audioPlayer.pause();
                    $('#play-icon').show();
                    $('#pause-icon').hide();
                }
            }
        }

        // Funció per anar a la pista següent
        function playNextTrack() {
            currentTrackIndex = (currentTrackIndex + 1) % playlist.length;

            if (checkMusic(playlist[currentTrackIndex])) {
                loadTrack(currentTrackIndex);
                audioPlayer.play();
                $('#play-icon').hide();
                $('#pause-icon').show();
            }
        }

        // Funció per anar a la pista anterior
        function playPrevTrack() {
            currentTrackIndex = (currentTrackIndex - 1 + playlist.length) % playlist.length;

            if (checkMusic(playlist[currentTrackIndex])) {
                loadTrack(currentTrackIndex);
                audioPlayer.play();
                $('#play-icon').hide();
                $('#pause-icon').show();
            }
        }

        function checkMusic(track) {
            if (typeof track === "string" && track.trim() !== "" || typeof track === "object" && track !== null) {
                return true
            } else {
                // NO SONG
                audioPlayer.pause();
                $('#play-icon').show();
                $('#pause-icon').hide();

                $('#track-name .error').addClass('animate');

                timeout = setTimeout(function () {
                    $('#track-name .error').removeClass('animate');
                }, 300);

                return false
            }
        }

        // Event Listeners
        $('#play-pause-button').on('click', togglePlayPause);
        $('#next-button').on('click', playNextTrack);
        $('#prev-button').on('click', playPrevTrack);
        $(audioPlayer).on('ended', playNextTrack); // Passa automàticament a la següent pista quan acaba
    }
}


$(document).ready(function () {
    Animations.init();
    Menu.init();
    dynamicViewHeight.init();
    Search.init();
    MenuMobile.init();
    Music.init();
});
$(document).on('shopify:section:load', function (event) {
    Animations.init();
    Menu.init();
    dynamicViewHeight.init();
    Search.init();
    MenuMobile.init();
    Music.init();
});